export const mapPagesWithPositions = (pages = [], returnPages = [], parentId = null) => {
  returnPages = pages.map((page, index) => {
    const newPage = { ...page, position_index: index, parent_id: parentId }
    if (page.children && page.children.length > 0) {
      newPage.children = mapPagesWithPositions(page.children, returnPages, page.id)
    }
    return newPage
  })
  return returnPages
}